module.exports = require('./lib/get.js').default;
